import React, { useEffect, useState } from "react";

export default function MultiplierInput(props) {
    const { id = "", multiplier = 0, multiplierType = 'percent', onChange = () => { } } = props
    const [m, setM] = useState(multiplier)
    const [mT, setMT] = useState(multiplierType)
    useEffect(() => {
        setM(multiplier)
        setMT(multiplierType)
    }, [multiplierType, multiplier])
    return (
        <div className="st-form-input-select position-relative no-arrows no-min-width mb-0 d-flex">
            <input
                type="number"
                className="st-fs-15"
                placeholder="0"
                id="multiplier"
                name="multiplier"
                value={m}
                onChange={(e) => {
                    setM(e.target.value)
                    props.onChange(id, e.target.value, mT)
                }}
            />
            <select
                value={mT}
                id="multiplierType"
                name="multiplierType"
                onChange={(e) => {
                    setMT(e.target.value)
                    onChange(id, m, e.target.value)
                }}
            >
                <option value="fixed">$</option>
                <option value="percent">%</option>
            </select>
        </div>
    );
}
